export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4784.f3f59302.jpg";